import React, { useEffect, useState } from "react";
import { BACKEND_URL } from "../../../config";

function Reviews() {
  const [reviews, setReviews] = useState([]);
  const [search, setSearch] = useState("");
  const [expandedIds, setExpandedIds] = useState([]); // NAYA: show more/less track karne ke liye

  const loadReviews = async () => {
    try {
      const res = await fetch(
        `${BACKEND_URL}/api.php?module=reviews&all=1`,
        {
          // FIX 1: credentials add kiya - session work karega
          credentials: "include"
        }
      );

      const data = await res.json();

      if (data.success) {
        setReviews(data.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    // Pehli baar load
    loadReviews();

    // FIX 2: har 5 second mein auto refresh - client ne review diya to dikhe
    const interval = setInterval(() => {
      loadReviews();
    }, 5000);

    // Component unmount hone par interval clear karo
    return () => clearInterval(interval);
  }, []);

  const updateStatus = async (id, status) => {
    const fd = new FormData();
    fd.append("action", "status");
    fd.append("id", id);
    fd.append("status", status);

    const res = await fetch(
      `${BACKEND_URL}/api.php?module=reviews`,
      {
        method: "POST",
        // FIX 1: yahan bhi credentials
        credentials: "include",
        body: fd
      }
    );

    const data = await res.json();

    if (data.success) {
      loadReviews();
    } else {
      alert(data.message || "Error");
    }
  };

  const getStatusClass = (status) => {
    if (status === "Pending") return "pending";
    if (status === "Approved") return "approved";
    if (status === "Rejected") return "rejected";
    return "";
  };

  // NAYA: comment expand/collapse toggle
  const toggleExpand = (id) => {
    setExpandedIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  // NAYA: lambe comment ko truncate karke "Show more/less" dena
  const renderComment = (r) => {
    const comment = r.comment || "";
    const isLong = comment.length > 120;
    const isExpanded = expandedIds.includes(r.id);

    if (!isLong) return comment;

    return (
      <>
        {isExpanded ? comment : comment.slice(0, 120) + "..."}
        <span className="show-toggle" onClick={() => toggleExpand(r.id)}>
          {isExpanded ? " Show less" : " Show more"}
        </span>
      </>
    );
  };

  const filteredReviews = reviews.filter(
    (r) =>
      r.productName?.toLowerCase().includes(search.toLowerCase()) ||
      r.comment?.toLowerCase().includes(search.toLowerCase()) ||
      r.status?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="admin-page">

      {/* CHANGE: inline style hata kar "page-header-bar" class lagayi - mobile pe stack hoga */}
      <div className="page-header-bar">
        <h2>Reviews</h2>

        <input
          type="text"
          className="page-search-input"
          placeholder="Search Product, Comment or Status..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* "reviews-table" class - sirf isi table ke liye CSS override lagega */}
      <div className="admin-table reviews-table">
        <table>

          <thead>
            <tr>
              <th>Product</th>
              <th>Rating</th>
              <th>Comment</th>
              <th>Status</th>
              <th>Date</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredReviews.length === 0 ? (
              <tr>
                <td colSpan="6" style={{ textAlign: "center", padding: "20px" }}>
                  No reviews found
                </td>
              </tr>
            ) : (
              filteredReviews.map((r) => (
                <tr key={r.id}>

                  <td>{r.productName}</td>

                  <td>{"⭐".repeat(r.rating)}</td>

                  <td className="comment-cell">{renderComment(r)}</td>

                  <td>
                    <span
                      className={`review-status ${getStatusClass(r.status)}`}
                      style={{
                        backgroundColor:
                          r.status === "Approved"
                            ? "#d7e7d2"   // light green
                            : r.status === "Rejected"
                            ? "#f8b1b1"   // light red
                            : "#f5e6a8",  // light yellow (pending)
                        color: "#000",
                        padding: "4px 10px",
                        borderRadius: "8px",
                        fontWeight: "600",
                        display: "inline-block"
                      }}
                    >
                      {r.status}
                    </span>
                  </td>

                  <td>
                    {new Date(r.createdAt).toDateString()}
                  </td>

                  <td className="action-btns">

                    <button
                      className="admin-btn view"
                      onClick={() => updateStatus(r.id, "Approved")}
                    >
                      Approve
                    </button>

                    <button
                      className="admin-btn delete"
                      onClick={() => updateStatus(r.id, "Rejected")}
                    >
                      Reject
                    </button>

                  </td>

                </tr>
              ))
            )}
          </tbody>

        </table>
      </div>

    </div>
  );
}

export default Reviews;
